export default __webpack_public_path__ + "static/media/if-you-are-3.5aea3aa2.svg";